import { useAuth } from "./useAuth";

export type TawaRole = "worker" | "manager" | "admin";

export function useRole(): TawaRole | null {
  const { user } = useAuth();
  if (!user?.profile) return null;
  const r = (user.profile as Record<string, unknown>)["TAWA_role"];
  if (r === "worker" || r === "manager" || r === "admin") return r;
  return null;
}
